import styled from "styled-components";
import { pxToRem } from "../../styles/utils";

export const SettingsPageContainer = styled.div`
  display: flex;
  height: calc(100% - ${pxToRem(24)});
  margin: ${pxToRem(12)};
`;

export const PageContent = styled.div`
  flex: 1;
  margin-left: 0;
  background: white;
  border-radius: ${pxToRem(16)};
  box-shadow: 0px ${pxToRem(9)} ${pxToRem(14.5)} rgba(0, 0, 0, 0.06),
    0px 0px ${pxToRem(6)} rgba(31, 10, 53, 0.05);
  padding: ${pxToRem(32)} ${pxToRem(25)};
  box-sizing: border-box;
`;

export const SectionHeader = styled.h1`
  font-size: ${pxToRem(32)};
  font-weight: 600;
  margin-bottom: ${pxToRem(20)};
  color: #1f0a35;
`;

export const FormsContainer = styled.div`
  height: ${pxToRem(450)};
  display: flex;
  gap: ${pxToRem(20)};
  align-items: start;
  justify-content: center;
  margin-top: ${pxToRem(180)};
`;
